import { SegmentSchema } from '@sondermind/segment';
import { IPslPageLoadEventData } from './segment-event-data.interface';

export enum PslSegmentEvents {
  PSL_PAGE_VIEW = 'Viewed a provider shareable link page'
}

export interface IPslSegmentSchema extends SegmentSchema {
  [PslSegmentEvents.PSL_PAGE_VIEW]: IPslPageLoadEventData;
}
